import * as React from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { Col, Layout, Row } from 'antd';
// import {withLastLocation} from 'react-router-last-location';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { connect } from 'react-redux';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import { getBackLinkStates } from '../../utils/HistoryUtils';
import { Helmet } from 'react-helmet';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const Color = require('color');
const style = require('./DetailPageHeader.less');

class DetailPageHeader extends React.Component<any, any> {
	componentDidMount() {
		const {
			updateNavbar,
			backLinkText,
			backLinkTo,
			backgroundColor = '#6237a0',
			location,
		} = this.props;

		const { backLinkText: text, backLinkTo: link } = getBackLinkStates(location, backLinkTo) as any;

		updateNavbar(
			text || backLinkText,
			link || backLinkTo,
			Color(backgroundColor).darken(0.2).toString()
		);
	}

	componentDidUpdate(prevProps) {
		const { updateNavbar, backLinkText, backLinkTo, backgroundColor = '#6237a0' } = this.props;

		if (
			backLinkText !== prevProps.backLinkText ||
			backLinkTo !== prevProps.backLinkTo ||
			Color(backgroundColor).hex() !== Color(prevProps.backgroundColor).hex()
		) {
			updateNavbar(backLinkText, backLinkTo, Color(backgroundColor).darken(0.2).toString());
		}
	}

	componentWillUnmount() {
		const { clearNavbar } = this.props;
		clearNavbar();
	}

	render() {
		const {
			exactPath,
			redirectPath,
			lastLocation,
			backLinkText,
			backLinkTo,
			avatar = null,
			title = null,
			subtitle = null,
			actions = null,
			backgroundColor = '#6237a0',
			tabs = [],
			handleTabChange,
			checkTabActive,
			childRoutes = [],
			subtext,
			tabsRightActions,
			additionalHeader = null,
			childBodyBackgroudColor,
			getHTMLTitle,
			companyConfig,
			...otherProps
		} = this.props;
		return (
			<div {...otherProps}>
				{redirectPath ? (
					<Route
						path={exactPath}
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: redirectPath,
								}}
							/>
						)}
					/>
				) : null}
				<Layout.Content
					id="detail-page"
					className="detailPage "
					style={{
						...(childBodyBackgroudColor && { backgroundColor: childBodyBackgroudColor }),
					}}
				>
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}
					{additionalHeader ? (
						<Row gutter={0} style={{ paddingBottom: 8, background: backgroundColor }}>
							{additionalHeader}
						</Row>
					) : null}
					<div
						style={{
							padding: '16px 40px 24px',
							paddingBottom: 0,
							background: backgroundColor || nullSafeGet('config.theme.navblock', companyConfig),
							marginBottom: '16px',
						}}
						className={this.props.headerClassName}
					>
						{getHTMLTitle ? (
							<Helmet>
								<title>{getHTMLTitle()}</title>
							</Helmet>
						) : null}
						<Row gutter={16} style={{ marginBottom: 8 }}>
							<Col
								lg={24}
								xl={16}
								xxl={18}
								style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}
							>
								{avatar ? avatar : null}
								<div style={{ width: '100%' }}>
									<h4 className="detailPage__title">{title}</h4>
									<div className="detailPage__subtitle">
										{subtitle ? <div className="h6 detailPage__subtitle">{subtitle}</div> : null}
										{subtext ? <div className="h5 detailPage__subtitle">{subtext}</div> : null}
									</div>
								</div>
							</Col>
							<Col
								lg={24}
								xl={8}
								xxl={6}
								style={{
									marginBottom: 16,
									flexWrap: 'wrap',
									display: 'flex',
									justifyContent: 'end',
									alignItems: 'center',
									alignContent: 'center',
								}}
							>
								{actions}
							</Col>
						</Row>
						<SubnavTabs
							tabsRightActions={tabsRightActions}
							tabs={tabs}
							onChange={handleTabChange}
							isActive={checkTabActive}
						/>
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Layout.Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config.detail,
});
const mapDispatchToProps = (dispatch) => ({
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
});
export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(DetailPageHeader));
